export default class PlaceholderManager {
  static questionPlaceholderKey(description) {
    if (description.includes("${") && description.includes("}")) {
      const firstIndex = description.indexOf("${");
      const secondIndex = description.indexOf("}");
      return description.slice(firstIndex + 2, secondIndex);
    }
  }

  static addNewPlaceholder(addedPlaceholder, allPlaceholderValues) {
    const checkAllPlaceholdersIncludeNewPlaceholder = allPlaceholderValues.find(
      (placeholderValue) =>
        placeholderValue.toLowerCase() === addedPlaceholder.toLowerCase()
    );
    if (
      checkAllPlaceholdersIncludeNewPlaceholder === undefined &&
      addedPlaceholder !== ""
    ) {
      allPlaceholderValues.push(addedPlaceholder);
    }
  }

  static questionPlaceholderValue(allPlaceholder, placeholderKey) {
    const placeholderObject = allPlaceholder?.find(
      (placeholder) => placeholder.placeholder === placeholderKey
    );
    return placeholderObject?.value;
  }
}
